import { render, staticRenderFns } from "./radarChart.vue?vue&type=template&id=d391dda4&scoped=true"
import script from "./radarChart.vue?vue&type=script&lang=js"
export * from "./radarChart.vue?vue&type=script&lang=js"
import style0 from "./radarChart.vue?vue&type=style&index=0&id=d391dda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d391dda4",
  null
  
)

export default component.exports